module.exports = __webpack_public_path__ + "img/INSPECTION CONVEYOR.56ad61cc.jpg";